import { useMutation } from '@tanstack/react-query';
import { useRef, useState } from 'react';
import { isEqual } from 'lodash-es';
import { submitScoreCard } from './api';

export const useScorecardAutoSaveHelper = ({
  atsApplicationId,
  scorecardId,
  questions = [],
}) => {
  const previousValuesRef = useRef({});
  const submitScoreCardMutation = useMutation({
    mutationFn: (payload) => submitScoreCard(payload),
  });
  const [isSaved, setIsSaved] = useState(null);

  const handleAutoSave = async (values) => {
    const currentValues = {
      rating: values.rating,
      feedback: values.feedback,
      ...values,
    };

    const { feedback_description, rating_description, ...currentValuesRest } =
      currentValues;

    const hasChanges = !isEqual(currentValuesRest, previousValuesRef.current);

    const hasValue = Object.values(currentValuesRest).some(
      (value) => value !== '' && value !== null && value !== undefined
    );

    if (!hasChanges || !hasValue) return;

    const payload = {
      rating: currentValuesRest.rating,
      feedback: currentValuesRest.feedback,
      questions: questions?.map((item, idx) => {
        const param = { question: item?.question };
        if (values?.[idx + 1]) param.answer = values?.[idx + 1];
        return param;
      }),
      status: 'draft',
    };

    setIsSaved('isLoading');

    try {
      await submitScoreCardMutation.mutateAsync({
        applicationId: atsApplicationId,
        scorecardId: scorecardId,
        payload,
      });
      previousValuesRef.current = currentValuesRest;
      setIsSaved('success');
    } catch (err) {
      setIsSaved('error');
    }
  };

  return { handleAutoSave, isSaved };
};
